import { parsePhoneNumber, getCountryCallingCode } from "libphonenumber-js";
import { findFlagUrlByIso2Code } from "country-flags-svg";

const parse = (msisdn, country) => {
    if(country === "xx") return msisdn;
    try {
        const parsed = parsePhoneNumber(msisdn, country.toUpperCase());
        return parsed.number.replace("+", "");
    } catch (e) {
        return msisdn;
    }
};

const isvalid = (msisdn, country) => {
    if(country === "xx") return true;
    try {
        const parsed = parsePhoneNumber(msisdn, country.toUpperCase());
        return parsed.isPossible();
    } catch (e) {
        return false;
    }
};

const getPlaceHolder = (country) => {
    if(country === 'xx') return "";
    country = country.toUpperCase();
    return getCountryCallingCode(country) + "xxxxxxxx"
}

const getFlag = (country) => {
    if(country === "xx") return null;
    else return findFlagUrlByIso2Code(country.toUpperCase());
}

export { parse, isvalid, getPlaceHolder, getFlag };


// WEBPACK FOOTER //
// ./src/utils/login.utils.js